import React, { Component } from 'react';
import * as events from '../utils/events';

import Typeahead from './typeahead';
import AllLocationsList from './all-locations-list';
import PropTypes from "prop-types";

/**
 * Returns the all cafes list view
 *
 * @param props
 * @returns {*}
 * @constructor
 */

export default class AllLocations extends Component {

	static propTypes = {
		stateRadius: PropTypes.string.isRequired,
	};

	componentDidMount() {
		events.trigger({ event: 'modern_tribe/locator/all_locations_mount', native: false, data: {} });
	}

	render () {
		return (
			<React.Fragment>
				<Typeahead {...this.props} radius={this.props.stateRadius} />
				<AllLocationsList {...this.props} />
			</React.Fragment>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/all-locations.js